"use client";
'use strict';

var React = require('react');
var dom = require('../utils/dom.js');
var useCallbackRef = require('./useCallbackRef.js');

/**
 * React hook to manage browser event listeners
 *
 * @param event the event name
 * @param handler the event handler function to execute
 * @param element the element to execute against (defaults to `document`)
 * @param options the event listener options
 * @example
 * ```javascript
 * useEventListener("transitionend", onFocus, element)
 * ```
 */
function useEventListener(event, handler, element = dom.isBrowser ? document : null, options) {
    const fn = useCallbackRef.useCallbackRef(handler);
    React.useEffect(() => {
        if (!element)
            return undefined;
        const listener = (event) => {
            fn(event);
        };
        element.addEventListener(event, listener, options);
        return () => {
            element.removeEventListener(event, listener, options);
        };
    }, [event, element, options, fn]);
    return () => {
        element?.removeEventListener(event, fn, options);
    };
}

exports.useEventListener = useEventListener;
//# sourceMappingURL=useEventListener.js.map
